<template>
    <div class="rocbox ">
        <div class="banner columns">
            <h1>RocBox</h1>
            <p>实现系统供电、数据通讯、自动化控制和数据智能处理一体化</p>
        
        </div>
        <!-- 介绍部分 -->      
            <div class="intro_center column">
                <h1>自动化变形监测终端</h1>
                <p>RocBox变形监测终端是北京奥腾岩石科技有限公司针对自动化变形监测领域的需求，自主研发的高集成度、高稳定性、高性价比监测终端。它弥补了自动化变形监测领域专业监测终端的空白，实现了系统供电、数据通讯、自动化控制和数据智能处理一体化。</p>
                <p>2015年北京奥腾岩石科技有限公司首次推出了 RT-1000变形监测终端，取得极大的行业影响力，2016年在原有的基础上进行了多项升级改进，革命性的推出RT-2000变形监测终端。RT-2000进一步优化了通讯、供电和制造工艺，并突破性的兼容多款国际 知名品 牌高精度北斗板卡，使得 RT-2000能适应更加复杂的监测环境，并打造出集测量机器人、北斗和岩土环境传感器联合监测的综合性自动化变形监测系统，成为自动化变形监测领域最为专业的变形监测终端。</p>
            </div>
        <!-- 产品特点 -->
         <div class="feature">
                    <div class="special">
              <h1>产品特点</h1>
              <div class="items_wrap row">
                  <div class="item_box column" v-for="item in features" :key="item.img">
                      <img :src="item.img" alt="">
                      <h3>{{item.title}}</h3>
                      <div class="line"></div>
                      <p>{{item.word}}</p>
                  </div>
              </div>
          </div>
          <img src="../assets/rocbox/bolang.png" alt="" class="bgi">
         </div>
         <!-- 研发背景 -->
         <div class="background rows">
             <div class="bgc_center column">
                 <h2>研发背景</h2>
                 <div class="bgword columns">
                     <p>随着我国社会经济的发展，对水利水电、矿山开采、轨道交通、道路桥梁、高层建筑等大型工程的建设而引起的地质灾害对经济建设和人民生命财产造成了巨大损失，虽然采用常规大地测量方法技术成熟，但是在监测数据的连续性、实时性和自动化程度等方面越来越难以满足现代高精度变形监测的需求。</p>
                     <p>作为影响民生的变形监测行业，却并没有成熟的监测终端，一般自动化变形监测系统多使用通用的通讯模块，功能单一，系统架构复杂，并非针对变形监测行业。北京奥腾岩石科技有限公司作为国内领先的安全监测解决方案供应商，为弥补自动化变形监测领域专业监测终端的空白，不断研究变形监测领域的特殊环境和专业需求，经过大量项目的实践和市场调研，研发出目前国内最为专业的 RocBox 变形监测终端</p>
                 </div>
             </div>
         </div>
         <!-- 解决方案 -->
         <div class="solution columns">
             <h2>解决方案</h2>
             <div class="solution_c row">
                <div class="solu_l rows">
                    <img src="../assets/rocbox/tu.png" alt="">
                </div>
                <img src="../assets/rocbox/tubiao.png" alt="" class="tubiao">
             </div>
         </div>
         <!-- 应用领域 -->
         <div class="area">
             <h2>应用领域</h2>
             <div class="area_img row" >
                 <div class="img_item " v-for="item in arealists" :key="item.title">
                     <img :src="item.img" alt="">
                     <div class="shadow columns" >
                      <h6>{{item.title}}</h6>
                     <div class="lines"></div>
                     </div>                   
                 </div>
             </div>
         </div>
      

      <!-- 监测终端 -->
    
       <div class="monitor">
           <div class="moni_center columns">
               <h2>监测终端</h2>
               <div class="moni_img rows">
                   <div class="img_bgc rows">
                      <img src="../assets/rocbox/tu2.png" alt="">
                   </div>             
               </div>
           </div>

       </div>

       <!-- 技术指标 -->
       <div class="indicator column">
           <h2>技术指标</h2>
           <div class="indicator_img rows">
              <img src="../assets/rocbox/jishu.png" alt="">
           </div>
       </div>
       <!-- 底部导航 -->
       <foot></foot>
    </div>
</template>

<script>
import footer from '../common/footer.vue'
export default {
  data() {
    return {
      // 产品特点
      features: [
        {
          img: require("../assets/rocbox/jicheng.png"),
          title: "高度的集成",
          word:
            "系统供电、数据通讯、自动化控制、数据智能处理和高精度北斗板卡于一体 ；4 个RS-232/485串口，含供电输出和远程电源管理模块，支持所有主流监测设备（拓普康、徕卡、天宝测量机器人，主流环境、岩土传感器）接入"
        },
        {
          img: require("../assets/rocbox/tongxun.png"),
          title: "强大的通讯",
          word:
            "100Mbps 网口，支持光纤、宽带通讯；内置IEEE 802.11 b/g/n 标准无线通讯模块；全网通蜂窝网络，支持移动、联通、电信的 4G/3G/2G 无线网络。"
        },
        {
          img: require("../assets/rocbox/zhineng.png"),
          title: "专业的智能",
          word:
            "直接读取和控制主流测量机器人，可接入数字量、模拟量、振弦式传感器数据；系统异常时自动 存贮数据、系统恢复时自动同步数据；内置网页控制界面；内置硬件看门狗。"
        }
      ],
      //   应用领域
      arealists: [
        {
          img: require("../assets/rocbox/ditie.png"),
          title: "地铁监测"
        },
        {
          img: require("../assets/rocbox/gaotie.png"),
          title: "高铁监测"
        },
        {
          img: require("../assets/rocbox/suidao.png"),
          title: "隧道监测"
        },
        {
          img: require("../assets/rocbox/huapo.png"),
          title: "滑坡监测"
        },
        {
          img: require("../assets/rocbox/weikuang.png"),
          title: "尾矿监测"
        },
        {
          img: require("../assets/rocbox/qiaoliang.png"),
          title: "桥梁监测"
        },
        {
          img: require("../assets/rocbox/daba.png"),
          title: "大坝监测"
        },
        {
          img: require("../assets/rocbox/wenwu.png"),
          title: "文物监测"
        }
      ]
    };
  },
  components:{
      "foot":footer
  }
};
</script>

<style>





* {
  margin: 0;
  padding: 0;
}
h2 {
  font-size: 0.36rem;
  font-family: MicrosoftYaHei;
  font-weight: 400;
  color: rgba(37, 43, 58, 1);
  line-height: 0.15rem;
  text-align: center;
}
.rocbox {
  margin: 0;
  padding: 0;
}
.banner {
  overflow-x: hidden;
  height: 3.5rem;
  z-index: -1;
  background-image: url("../assets/rocbox/banner.png");
  background-repeat: no-repeat;
  background-size: 100% 100%;
}

.banner h1 {
  width: 1.91rem;
  height: 0.36rem;
  font-size: 0.48rem;
  font-family: Longview;
  color: rgba(255, 255, 255, 1);
  line-height: 0.15rem;
  text-align: center;
}
.banner p {
  margin-top: 0.25rem;
  font-size: 0.16rem;
  font-family: MicrosoftYaHei;
  font-weight: 400;
  color: rgba(255, 255, 255, 1);
  text-align: center;
}

.intro_center {
  width: 12rem;
  height: 2.71rem;
  margin: 0 auto;
  margin-top: -0.51rem;
  z-index: 99;
  background-image: url("../assets/rocbox/beijing.png");
  background-repeat: no-repeat;
  background-size: 100% 100%;
  padding: 0 0.41rem;
}
.intro_center h1 {
  font-size: 0.24rem;
  font-family: MicrosoftYaHei;
  font-weight: 400;
  color: rgba(37, 43, 58, 1);
  line-height: 0.15rem;
  padding-top: 0.37rem;
  padding-bottom: 0.37rem;
}
.intro_center p {
  font-size: 0.14rem;
  font-family: MicrosoftYaHei;
  font-weight: 400;
  color: rgba(102, 106, 117, 1);
  padding-bottom: 0.21rem;
}
.special {
  width: 12rem;
  margin: 0 auto;
  z-index: 99;
}
.special h1 {
  font-size: 0.36rem;
  font-family: MicrosoftYaHei;
  font-weight: 400;
  color: rgba(37, 43, 58, 1);
  line-height: 0.15rem;
  text-align: center;
  margin-top: 1rem;
}

.special .items_wrap {
  width: 12rem;
  justify-content: space-between;
}
.special .item_box {
  width: 3.8rem;
  height: 3.67rem;
  margin-top: 0.38rem;
  background: rgba(255, 255, 255, 1);
  box-shadow: 0 0.05rem 0.11rem 0 rgba(223, 224, 233, 1);
  align-items: center;
  cursor: pointer;
}
.special .line {
  width: 0.24rem;
  height: 0.02rem;
  background: rgba(67, 148, 208, 1);
}
.special h3 {
  font-size: 0.18rem;
  font-family: MicrosoftYaHei;
  font-weight: 400;
  color: rgba(37, 43, 58, 1);
  line-height: 0.15rem;
  margin-bottom: 0.24rem;
}
.special h3:hover,
.special p:hover{
     color: #409eff;
}

.special img {
  width: 0.42rem;
  height: 0.38rem;
  margin-top: 0.52rem;
  margin-bottom: 0.33rem;
}
.special p {
  width: 2.94rem;
  height: 1.11rem;
  font-size: 0.14rem;
  font-family: MicrosoftYaHei;
  font-weight: 400;
  color: rgba(102, 106, 117, 1);
  margin-top: 0.24rem;
}
.feature {
  position: relative;
}
.feature .bgi {
  width: 100%;
  height: 4rem;
  position: absolute;
  left: 0;
  bottom: 0;
  z-index: -1;
}
.background {
  width: 100%;
  height: 3.8rem;
  background: rgba(250, 250, 250, 1);
}
.bgc_center {
  width: 12rem;
  height: 3.8rem;
  align-content: center;
}
.bgword p {
  font-size: 0.14rem;
  font-family: MicrosoftYaHei;
  font-weight: 400;
  color: rgba(102, 106, 117, 1);
}
.bgc_center h2 {
  margin-top: 0.56rem;
  text-align: center;
  margin-bottom: 0.36rem;
}
.bgword {
  height: 2.02rem;
  background: rgba(255, 255, 255, 1);
  border: 0.01rem solid rgba(221, 221, 221, 1);
  border-radius: 0.02rem;
  padding: 0 0.33rem;
  margin:0 auto;
}
.bgword p {
  padding-bottom: 0.22rem;
}
.solution h2 {
  padding-top: 0.55rem;
  text-align: center;
  padding-bottom: 0.36rem;
}
.solution_c {
  width: 12rem;
  height: 5.29rem;
  justify-content: space-between;
  background: rgba(255, 255, 255, 1);
  border: 0.01rem solid rgba(221, 221, 221, 1);
  border-radius: 0.02rem;
}
.solu_l {
  width: 7.54rem;
  height: 4.69rem;
  margin: 0.3rem;
  background: rgba(247, 247, 247, 1);
}
.solution_c .tubiao {
  width: 1.75rem;
  height: 3.8rem;
  margin-top: 0.67rem;
  margin-right: 1.22rem;
}
.solu_l img {
  width: 5.22rem;
  height: 2.81rem;
}
.area h2 {
  padding-top: 0.67rem;
  padding-bottom: 0.36rem;
}
.area_img {
  width: 12rem;
  height: 5.16rem;
  flex-wrap: wrap;
  justify-content: space-between;
  margin: 0 auto;
}
.img_item {
  width: 2.85rem;
  height: 2.48rem;
  position: relative;
  cursor: pointer;
}
.img_item img{
  width: 100%;
  height: 100%;
}
.img_item .shadow {
  position: absolute;
  top: 0;
  left: 0;
  width: 2.85rem;
  height: 2.48rem;
  background: #0c2233;
  opacity: 0.5;
}
.shadow .lines {
  width: 0.24em;
  height: 0.02rem;
  margin-top: .2rem;
  background: rgba(245, 245, 245, 1);
  cursor: pointer;
}
.shadow h6 {
  font-size: 0.18rem;
  font-family: MicrosoftYaHei;
  font-weight: 400;
  color: rgba(255, 255, 255, 1);
  cursor: pointer;
}
.shadow h6:hover
{
     color: rgba(67,148,208,1);
}
.shadow .lines:hover{
    background-color: #409eff;
}
.monitor {
  width: 100%;
  height: 9.06rem;
  background: rgba(245, 245, 245, 1);
  margin-top: 0.57rem;
}
.monitor h2 {
  padding-top: 0.55rem;
  padding-bottom: 0.36rem;
}
.monitor .moni_img {
  width: 12rem;
  height: 7.07rem;
  background: rgba(255, 255, 255, 1);
  border: 0.01rem solid rgba(221, 221, 221, 1);
  border-radius: 0.02rem;
  cursor: pointer;
}
.img_bgc {
  width: 11.4rem;
  height: 6.47rem;
  background: rgba(247, 247, 247, 1);
}
.img_bgc img {
  width: 10.15rem;
  height: 5.7rem;
}
.indicator {
  width: 12rem;
  height: 18.58rem;
  margin: 0 auto;
}
.indicator h2 {
  padding-top: 0.56rem;
  padding-bottom: 0.36rem;
}
.indicator .indicator_img {
  width: 12rem;
  height: 17rem;
  background: rgba(255, 255, 255, 1);
  border: 0.01rem solid rgba(221, 221, 221, 1);
  border-radius: 0.02rem;
  margin-bottom: .67rem;
}
.indicator_img img {
  width: 9.88rem;
  height: 15.39rem;
}
</style>


// WEBPACK FOOTER //
// src/homepages/rocbox.vue